import Vue from 'vue'
import { Alert, Confirm, IToast, Prompt } from './install'
// 添加手势触摸事件，使用方法如 v-touch:swipeleft
import VueTouch from '@/im/plugins/touchEvent'
Vue.use(VueTouch)

Vue.use(Alert)
Vue.use(Confirm)
Vue.use(IToast)
Vue.use(Prompt)



// WEBPACK FOOTER //
// ./src/plugins/index.js